module.exports = __webpack_public_path__ + "img/play_pause_rectangle.d9d56349.svg";